import React from 'react';
import { Table as TableAntD } from 'antd';
import { TableProps } from 'antd/es/table';

export const Table: React.FC<TableProps> = (props) => {
	return <TableAntD {...props} />;
};
